import type { RunnerLevel, RunnerPlayer } from './runnerTypes';

export function hasRunnerReachedFinish(level: RunnerLevel, player: RunnerPlayer): boolean {
  return player.worldS >= level.routeEndS;
}
